import { observer } from 'mobx-react';
import * as React from 'react';
import { TextField } from '@components/textfield';
import { Label } from '@components/ui/label';
import { Switch } from '@components/ui/switch';
import { injectTSDI } from '@core/tsdi';
import { ChallengeDataStore } from '../../data-store';
import { RuleSetSection } from '../rule-set-section';
import { ChallengeRulesStore } from '../store';
import { PersonalRulesStore } from './store';

const PersonalRules = observer(() => {
    const { disabledRulesEdit } = injectTSDI(ChallengeDataStore);
    const { validateRules } = injectTSDI(ChallengeRulesStore);
    const {
        fields: {
            allowedWinnersCount,
            qualificationThreshold,
            leaderboardEnabled
        },
        form
    } = injectTSDI(PersonalRulesStore);

    return (
        <RuleSetSection
            title="Personal Rules"
            enabled
            toggleDisabled
            toggleTestId="challenge-team-rules"
            disabled={disabledRulesEdit}
            error={Boolean(form.error)}
        >
            <div className="flex flex-col gap-2">
                <Label htmlFor="leaderboardEnabled">Leaderboard Enabled</Label>
                <Switch
                    id="leaderboardEnabled"
                    checked={leaderboardEnabled.value}
                    onCheckedChange={(checked) => {
                        leaderboardEnabled.onChange(checked);
                    }}
                    name="leaderboardEnabled"
                    disabled={disabledRulesEdit}
                />
            </div>
            <div className="grid gap-4 md:grid-cols-2">
                <TextField
                    type="number"
                    label="Allowed winners count"
                    value={allowedWinnersCount.value || ''}
                    onChange={(value) => {
                        allowedWinnersCount.onChange(Number(value));
                        validateRules();
                        form.validate();
                    }}
                    error={allowedWinnersCount.error}
                    InputLabelShrink
                    data-testid={`allowed-winners-count-challenge-goal-field`}
                    disabled={disabledRulesEdit}
                />
                <TextField
                    type="number"
                    label="Qualification threshold"
                    value={qualificationThreshold.value || ''}
                    onChange={(value) => {
                        qualificationThreshold.onChange(
                            Number(value) || undefined
                        );
                        validateRules();
                        form.validate();
                    }}
                    error={qualificationThreshold.error}
                    InputLabelShrink
                    data-testid={`qualification-threshold-challenge-goal-field`}
                    disabled={disabledRulesEdit}
                />
            </div>
        </RuleSetSection>
    );
});

export default PersonalRules;
